import type { ReactNode, RefObject } from "react";
import { Menu } from "@theorgchartdev/storybook";
import type { OpenCtrlRef } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import type { SettingMenuOption } from "./useSettingsMenuOptions";

type SettingsMenuProps = {
  trigger: ReactNode;
  settingOptions: SettingMenuOption[];
  canAccessSettings: boolean;
  menuOpenCtrlRef: RefObject<OpenCtrlRef | null>;
};

// Takes data as props, rather than calling useSettingsMenuOptions() itself, so
// callers that already hold the hook's result don't pay for a second call.
export const SettingsMenu = ({
  trigger,
  settingOptions,
  canAccessSettings,
  menuOpenCtrlRef
}: SettingsMenuProps) => {
  if (!(settingOptions.length > 0 && canAccessSettings)) return null;

  return (
    <Menu
      listHeader={{ label: appstr("Settings") }}
      trigger={trigger}
      stayOpenOnOptionSelect
      openCtrlRef={menuOpenCtrlRef}
      options={settingOptions}
      position="right-end"
      listWidth="medium"
    />
  );
};
